export const updateHomeResources = "Update HomeResources Mutation";
export const resetHomeState = "Reset Home State Mutation";
